import * as _ from 'lodash';
import createSelector from 'selectorator';
import { User } from '../../types';
import { ReduxStore } from '../store';

const getUsers = createSelector(['users.users']);
const getUserList = createSelector([getUsers], _.values);

const getOrganizationUserIds = (state, props) =>
  props.organization && props.organization.users.map((user: User) => Number(user.id));
const getUsersByOrganization =
  createSelector([getUserList, getOrganizationUserIds], (allUsers, organizationUserIds) => {
    return allUsers
      .reduce((coll, user) => {
        if (!organizationUserIds.includes(Number(user.id))) {
          return coll;
        }
        coll[user.id] = user;
        return coll;
      }, {});
  });

const getUpdatingUsers = (state: ReduxStore) => state.users.updatingUsers;

// getLoadingUpdatingUsers returns the IDs of users in the updatingUsers object that have loading=true in the status.
const getLoadingUpdatingUsers = (state: ReduxStore): Set<number> =>
  Object.entries(state.users.updatingUsers)
    .reduce((acc, [userId, status]) => {
      if (status.loading) {
        acc.add(Number(userId));
      }
      return acc;
    }, new Set<number>());

const userSelectors = {
  getUsers,
  getUserList,
  getStatus: createSelector(['users.status']),
  getCurrentUser: (state: ReduxStore, props) => state.users.users[props.userId || window.user.id] || null,
  getUser: (state: ReduxStore, userId: number) => userId ? state.users.users[userId] : undefined,
  getUsersByOrganization,
  getUpdatingUsers,
  getLoadingUpdatingUsers,
};

export default userSelectors;
